import React from "react"
import {Box, Typography} from "@mui/material"

import type {ChannelPresenter} from "../channelPresenter"
import type {IdentificationHint, UnidentifiedMessage} from "../types"

import {DeferralReasonChip, HintChip, ReceivedAgo, SourceChip, StatusChip} from "./chips"
import {ConversationIDLine} from "./ConversationIDLine"

function ItemHeader({
	message,
	presenter,
	hints = [],
}: {
	message: UnidentifiedMessage
	presenter: ChannelPresenter
	hints?: IdentificationHint[]
}) {
	return (
		<Box display="flex" flexDirection="column" gap={2} mb={4}>
			<Typography variant="h5" component="h1" fontWeight={600}>
				{presenter.title(message)}
			</Typography>
			<Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
				<DeferralReasonChip reason={message.DeferralReason} />
				{hints.map((hint) => (
					<HintChip key={`${hint.Kind}:${hint.Label}`} hint={hint} />
				))}
				<SourceChip label={presenter.sourceLabel(message)} />
				<StatusChip status={message.Status} message={message} />
				<ReceivedAgo receivedAt={message.ReceivedAt} />
			</Box>
			<ConversationIDLine conversationID={message.ConversationID} />
		</Box>
	)
}

export {ItemHeader}
